// extracted by mini-css-extract-plugin
module.exports = {"terms":"pc_terms__rKZoy","main":"pc_main__ciWiq"};